import * as yup from 'yup';

export const formSchema = yup.object({
  isEmail: yup.boolean(),
  email: yup.string().email('Please enter a valid email address'),
});
